// extracted by mini-css-extract-plugin
export default {"captcha":"ReCaptcha_captcha__gBPsR"};